import { startTest } from '../../test/util.js';
import './arrivalPieSpec.js';

startTest();
